import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import { of } from 'rxjs';
import { SetTitle, SetTags } from '../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe, getDictionaryLoaded, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { CanActivateFn } from '@angular/router';

export const MetaGuard: CanActivateFn = route => {
  const store = inject(Store);
  const lang = inject(LanguageService);
  const dict = new FromDictionaryPipe(lang);

  return store
    .select(getDictionaryLoaded)
    .pipe(
      filter(loaded => loaded),
      tap(loaded => {
        store.dispatch(SetTitle({ title: dict.transform('meta-titel') }));
        store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(dict.transform('meta-omschrijving'), 157, '...'),
              'og:image': dict.transform('meta-afbeelding'),
              'og:title': dict.transform('meta-titel'),
              'og:description': StringUtility.Truncate(dict.transform('meta-omschrijving'), 157, '...'),
            },
          })
        );
      }),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
